import PropTypes from "prop-types";
import React, { ReactNode } from "react";

import { ToolTip } from "../../AbstractElements";

interface TooltipLabelProps {
  tooltipText: string | string[];
  placement?: "top" | "bottom" | "left" | "right";
  toolTipUniqueId: any;
  children: ReactNode;
}

const TextTooltip: React.FC<TooltipLabelProps> = ({
  tooltipText,
  placement = "top",
  toolTipUniqueId,
  children,
}) => {
  return (
    <div className="text-tooltip-wrapper">
      <div id={`TooltipIcon${toolTipUniqueId}`} className="tooltip-label">
        {children}
      </div>
      <ToolTip placement={placement} target={`TooltipIcon${toolTipUniqueId}`}>
        {tooltipText}
      </ToolTip>
    </div>
  );
};

TextTooltip.propTypes = {
  tooltipText: PropTypes.any,
  placement: PropTypes.oneOf(["top", "bottom", "left", "right"]),
  toolTipUniqueId: PropTypes.any,
  children: PropTypes.any,
};

export default TextTooltip;
